<template>
  <div class="app-container medal-detail">
    <basic-container>
      <el-tabs v-model="activeName" @tab-click="onTabShow">
        <el-tab-pane label="基本资料" name="detail">
          <el-row class="medal-detail-item">
            <el-col :span="3" class="head">ID:</el-col>
            <el-col :span="16">{{medalDetail.id}}</el-col>
          </el-row>
          <el-row class="medal-detail-item">
            <el-col :span="3">勋章名称:</el-col>
            <el-col :span="16">{{medalDetail.name}}</el-col>
          </el-row>
          <el-row class="medal-detail-item">
            <el-col :span="3">勋章描述:</el-col>
            <el-col :span="16">{{medalDetail.description}}</el-col>
          </el-row>
          <el-row class="medal-detail-item">
            <el-col :span="3">勋章分组:</el-col>
            <el-col :span="16">{{medalDetail.groupName}}</el-col>
          </el-row>
          <el-row class="medal-detail-item" >
            <el-col :span="3">未点亮图标:</el-col>
            <el-col :span="16">
              <div class="medal-image" v-if="medalDetail.unlitUrl">
                <img :src="medalDetail.unlitUrl" v-viewer>
              </div>
            </el-col>
          </el-row>
          <el-row class="medal-detail-item" >
            <el-col :span="3">点亮图标:</el-col>
            <el-col :span="16">
              <div class="medal-image" v-if="medalDetail.litUrl">
                <img :src="medalDetail.litUrl" v-viewer>
              </div>
            </el-col>
          </el-row>
          <el-row class="medal-detail-item">
            <el-col :span="3">勋章等级:</el-col>
            <el-col :span="16">{{medalDetail.grade}}</el-col>
          </el-row>
          <el-row class="medal-detail-item">
            <el-col :span="3">勋章等级名称:</el-col>
            <el-col :span="16">{{medalDetail.gradeName}}</el-col>
          </el-row>
          <el-row class="medal-detail-item">
            <el-col :span="3">勋章规则:</el-col>
            <el-col :span="16">{{medalDetail.medalRule}}</el-col>
          </el-row>
          <el-row class="medal-detail-item">
            <el-col :span="3">勋章获取条件:</el-col>
            <el-col :span="16">{{medalDetail.condition}}</el-col>
          </el-row>
          <el-row class="medal-detail-item">
            <el-col :span="3">是否启用:</el-col>
            <el-col :span="16">{{medalDetail.isActive? '已启用' : '已禁用'}}</el-col>
          </el-row>
          <el-row class="medal-detail-item">
            <el-col :span="3">排序优先级:</el-col>
            <el-col :span="16">{{medalDetail.sort}}</el-col>
          </el-row>
          <el-row class="medal-detail-item">
            <el-col :span="3">创建时间:</el-col>
            <el-col :span="16">{{medalDetail.insertedTime}}</el-col>
          </el-row>
        </el-tab-pane>

        <el-tab-pane label="发放记录列表" name="record">
          <div class="record-filter">
            <el-row>
              <el-col :span="6">
                <div class="grid-content bg-purple">
                  <el-input class="record-filter-value" v-model.trim="recordSearch.memberName" @keyup.enter.native="getRecordList" placeholder="请输入昵称或姓名" clearable size="small" ></el-input>
                </div>
              </el-col>
              <el-col :span="6">
                <div class="grid-content bg-purple">
                  <el-input class="record-filter-value" v-model.trim="recordSearch.unionId" @keyup.enter.native="getRecordList" placeholder="请输入员工号" clearable size="small"></el-input>
                </div>
              </el-col>
              <el-col :span="12">
                <div>
                  <el-button class="record-filter-reset" size="small" @click="getRecordList">立即筛选</el-button>
                  <el-button class="record-filter-search" size="small" @click="recordSearchReset">清除条件</el-button>
                </div>
              </el-col>
            </el-row>
          </div>
          <avue-crud ref="crud"
            :option="medalMemberOption"
            :data="recordData"
            :page="recordPage"
            :table-loading="recordListLoading"
            @current-change="recordCurrentPageChange"
            @size-change="recordPageSizeChange"
            @sort-change="recordPageSortChange">
          </avue-crud>
        </el-tab-pane>
      </el-tabs>
    </basic-container>
  </div>
</template>

<script>
import { getMedalDetail, getMedalMemberRecordList } from '@/api/medal/medal'
import { medalRules } from '@/const/crud/medal/medal'
import { medalMemberOption } from '@/const/crud/medal/record'

const initDetail = vm => {
  getMedalDetail(vm.id).then(response => {
    let data = response.data
    if (response.status == 200) {
      formatMedalDetail(vm.medalDetail, data.data);
    } else {
      vm.$message({
        showClose: true,
        message: '无法查看该勋章详情',
        type: 'error'
      });
    }
  }).catch(error => {
    vm.$message({
      message: '获取勋章详情失败',
      type: 'error'
    });
  });
}

const formatMedalDetail = (vm, data) => {
  vm.id = data.id;
  vm.name = data.name;
  if (!data.description) vm.description = "--";
  else vm.description = data.description;
  if (!data.groupName) vm.groupName = "未分组";
  else vm.groupName = data.groupName;
  vm.unlitUrl = data.unlitUrl;
  vm.litUrl = data.litUrl;
  if (!data.medalRule) vm.medalRule = "--";
  else vm.medalRule = medalRules.find(item => item.value === data.medalRule).label;
  if (!data.grade) vm.grade = "--";
  vm.grade = data.grade;
  if (!data.gradeName) vm.gradeName = "--";
  vm.gradeName = data.gradeName;
  vm.condition = data.condition;
  vm.isActive = data.isActive;
  vm.sort = data.sort;
  vm.insertedTime = data.insertedTime;
}

export default {
  data() {
    return {
      id: 0,
      activeName: "detail",
      medalDetail:{
        id: undefined,
        name: "",
        description: "",
        groupName: "",
        unlitUrl: "",
        litUrl: "",
        medalRule: "",
        grade: undefined,
        gradeName: "",
        condition: "",
        isActive: "",
        sort: 0,
        insertedTime: "",
      },
      medalMemberOption,
      recordListLoading: false,
      recordData: [],
      recordPage: {
        total: 0, // 总页数
        currentPage: 1, // 当前页数
        pageSize: 10, // 每页显示多少条,
      },
      recordSearch: {
        currentPage: 1,
        pageSize: 10,
        sortField: '',
        sortPolicy: '',
        memberName: '',
        unionId: '',
      },
    }
  },
  watch: {
    $route() {
      this.id = this.$route.params.id
      initDetail(this)
    }
  },
  mounted() {
    this.id = this.$route.params.id
    initDetail(this)
  },
  methods: {
    onTabShow(tab) {
      switch (tab.name) {
        case 'record':
          this.getRecordList();
          break;
      }
    },
    getRecordList(){
      this.recordListLoading = true
      getMedalMemberRecordList(this.generateFilterParams()).then(response => {
        if (response.data.data != null) {
          this.recordData = response.data.data.records
          this.recordData.forEach(record => {
            record.recordToNickname = record.memberInfo ? record.memberInfo.nickname || '--' : '--'
            record.recordToRealname = record.memberInfo ? record.memberInfo.realname || '--' : '--'
            record.recordToUnionId = record.memberInfo ? record.memberInfo.unionId || '--' : '--'
            record.recordByName = record.issuerName || 'system'
            record.recordTime = record.insertedTime
          })
          this.recordPage.total = response.data.data.total
          this.recordListLoading= false
        } else  {
          this.recordData = null
          this.recordPage.total = 0
        }
      }).catch(error => {
        this.$message({
          showClose: true,
          message: '获取该勋章的发放记录列表失败',
          type: 'error'
        })
        this.recordListLoading= false
      })
    },
    generateFilterParams() {
      let params = {
        current: this.recordSearch.currentPage,
        size: this.recordSearch.pageSize,
        medalId: this.id,
      };

      if (this.isNotEmpty(this.recordSearch.memberName)) {
        params.memberName = this.recordSearch.memberName;
      }

      if (this.isNotEmpty(this.recordSearch.unionId)) {
        params.unionId = this.recordSearch.unionId;
      }

      if (this.isNotEmpty(this.recordSearch.sortField)) {
        params.sortField = this.recordSearch.sortField;
      } else {
        params.sortField = 'inserted_time';
        this.recordSearch.sortField = params.sortField;
      }

      if (this.isNotEmpty(this.recordSearch.sortPolicy)) {
        params.sortPolicy = this.recordSearch.sortPolicy;
      } else {
        params.sortPolicy = 'desc';
        this.recordSearch.sortPolicy = params.sortPolicy;
      }

      return params;
    },
    recordSearchReset() {
      this.recordSearch.memberName = ''
      this.recordSearch.unionId = ''
      this.recordSearch.sortField = ''
      this.recordSearch.sortPolicy = ''
      this.getRecordList()
    },
    recordCurrentPageChange(val) {
      this.recordPage.currentPage = val
      this.recordSearch.currentPage = val
      this.getRecordList()
    },
    recordPageSizeChange(val) {
      this.recordPage.pageSize = val
      this.recordSearch.pageSize = val
      this.getRecordList()
    },
    recordPageSortChange(val) {
      if (val.prop == 'insertedTime') {
        this.recordSearch.sortField = 'inserted_time'
      } else {
        this.recordSearch.sortField = ''
      }
      if (val.order == 'ascending') {
        this.recordSearch.sortPolicy = 'asc'
      } else if (val.order == 'descending') {
        this.recordSearch.sortPolicy = 'desc'
      } else {
        this.recordSearch.sortPolicy = ''
      }
      this.getRecordList();
    },
    isNotEmpty(searchValue) {
      return searchValue != '' && searchValue.trim() != '';
    },
  }
}
</script>

<style lang="scss" scoped>

.medal-detail {
  .medal-detail-item {
    font-size: 16px;
    margin: 10px 0;
    &-button {
      margin: 0 0;
      color: #409EFF;
      text-align: center;
    }
  }
  .record-filter {
    margin: 0 10px;
    /deep/ .el-input__inner {
      font-size: 14px;
    }
    &-value {
      width: 96% !important;
    }
    &-search {
      float: right;
      margin-right: 8px;
    }
    &-reset {
      float: right;
      margin-right: 10px;
      border-color: #5383f3;
      color: #5383f3;
    }
  }
}

.vue-poll .ans-cnt .ans .bg{
  position: absolute;
  width: 0;
  top: 0;
  left: 0;
  bottom: 0;
  z-index: 0;
  background-color: #409eff;
  border-top-left-radius: 5px;
  border-bottom-left-radius: 5px;
}
.medal-image {
  display: flex;
  width: fit-content;
  border: 1px solid #eee;
  padding: 10px;
  img {
    width: 100px;
    height: 100px;
    max-width: 100%;
  }
}
.medal-content {
  border: 1px solid #eee;
  padding: 10px;
  /deep/ .mc-img {
    max-width: 100%;
  }
  /deep/ a {
    color: #105b89;
    text-decoration: underline;
  }
  /deep/ p {
    color: #000000;
  }
  /deep/ .mc-file {
    display: flex;
    align-items: flex-start;
    font-size: 14px;
    padding: 3px;
    line-height: 20px;
    text-decoration: none;
    color: #01396B;
    .mc-file-icon {
      background: url(../../../static/images/editor/file.svg) no-repeat center;
      background-size: 80%;
      display: inline-block;
      width: 20px;
      height: 20px;
      margin-right: 8px;
    }
  }
  /deep/ table {
    margin: 1em 0;
  }
}

.medal-content-text {
  white-space: pre-wrap;
}

.mc-img {
  max-width: 100%;
}
/deep/.el-dialog {
  box-shadow: none;
  background: none;
}
/deep/.el-dialog__headerbtn {
  right: -20px;
  font-size: 20px;
}


</style>
